// src/landing/components/FooterSection.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../common/contexts/LanguageContext';
import '../../landing/styles/FooterSection.css';

const APP_STORE   = '/assets/app_store_badge.png';
const GOOGLE_PLAY = '/assets/google_play_badge.png';

export default function FooterSection() {
  const { t } = useContext(LanguageContext);

  return (
    <footer className="footer-wrap">
      <div className="footer-container">
        {/* ───── 왼쪽: 회사 정보 ───── */}
        <div className="footer-left">
          <p>
            <strong>{t('footerSection.company')}</strong>&nbsp;&nbsp;&nbsp;
            {t('footerSection.ceo')}&nbsp;|&nbsp;
            {t('footerSection.privacyOfficer')}&nbsp;|&nbsp;
            {t('footerSection.businessNumber')}
          </p>
          <p>{t('footerSection.address')}</p>

          <div className="footer-links">
            <Link to="/legal?tab=terms">{t('footerSection.links.terms')}</Link>
            <Link to="/legal?tab=privacy">{t('footerSection.links.privacy')}</Link>
            <span className="divider">|</span>
            <span>{t('footerSection.links.support')}</span>
          </div>

          <p className="copyright">
            {t('footerSection.copyright')}
          </p>
        </div>

        {/* ───── 오른쪽: 다운로드 배지 ───── */}
        <div className="footer-right">
          <img
            src={APP_STORE}
            alt={t('footerSection.alt.appStore')}
          />
          <img
            src={GOOGLE_PLAY}
            alt={t('footerSection.alt.googlePlay')}
          />
        </div>
      </div>
    </footer>
  );
}
